<template>
  <span v-if="text" class="flex align-items-center gap-1">
    <span class="text-sm">{{ preview }}</span>
    <i
      class="pi pi-info-circle text-500 cursor-pointer"
      v-tooltip.top="text"
    ></i>
  </span>
  <span v-else class="text-500 text-sm">—</span>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  text: { type: String, default: null },
  charLimit: { type: Number, default: 10 },
});

const preview = computed(() => props.text.slice(0, props.charLimit));
</script>
